const MAX_EMAIL_LENGTH = 255;
// The first character cannot be = + - so a CSV cell holding the email is never read as a spreadsheet formula.
// Commas and semicolons are excluded because the bulk list is split on them.
const EMAIL_PATTERN = /^[^\s@,;=+-][^\s@,;]*@[^\s@,;]+\.[^\s@,;]+$/;

// Returns '' when the email is valid, otherwise the message to show.
export function getEmailError(email) {
  if (email.length > MAX_EMAIL_LENGTH) {
    return `Email must be at most ${MAX_EMAIL_LENGTH} characters.`;
  }
  return EMAIL_PATTERN.test(email) ? '' : 'The input is not a valid email.';
}

export function parseEmailList(text) {
  const seen = new Set();
  const valid = [];
  const invalid = [];
  let duplicates = 0;
  text
    .split(/[\s,;]+/)
    .filter(Boolean)
    .forEach((email) => {
      if (getEmailError(email)) {
        invalid.push(email);
      } else if (seen.has(email.toLowerCase())) {
        duplicates += 1;
      } else {
        seen.add(email.toLowerCase());
        valid.push(email);
      }
    });
  return { valid, invalid, duplicates };
}
